import { Box, useTheme } from '@mui/material'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { CardContainer, CardTitle } from '../common/styles'
import { HeaderWrapper } from '../MetricCard/styles'
import { ProgressBar, ProgressContainer, ValueText } from '../ProgressRow/styles'
import { NEUTRAL_COLOR } from '../common/utils'
import { ConversionCardProps } from './types'
import { BootstrapTooltip } from 'components/BootstrapTooltip'
import { FUTURE_SALES_MESSAGE, isFieldDisabled } from 'utils/reportDisabledFields'
import {
  CONVERSION_EXPLANATION,
  formatConversionRate,
  getConversionRate
} from 'utils/conversion'

const CONVERSION_COLOR = '#2A3ECB'

// Conversão geral das lojas com contagem de pessoas. Segue o layout dos
// MetricCards, mas a barra mostra a própria taxa: não há meta de conversão.
export const ConversionCard = ({
  disabledReason,
  conversion
}: ConversionCardProps) => {
  const theme = useTheme()
  const disabled = isFieldDisabled(disabledReason)
  const rate = getConversionRate(conversion) ?? 0

  return (
    <CardContainer>
      <HeaderWrapper>
        <CardTitle>CONVERSÃO</CardTitle>
        <Box sx={{ width: theme.spacing(1) }} />
        <BootstrapTooltip title={CONVERSION_EXPLANATION}>
          <ErrorOutlineIcon
            style={{ color: '#C4C4C4', fontSize: 16, alignSelf: 'center' }}
          />
        </BootstrapTooltip>
      </HeaderWrapper>

      <div>
        <ProgressContainer>
          {disabled
            ? (
              <BootstrapTooltip title={FUTURE_SALES_MESSAGE}>
                <ValueText small color={NEUTRAL_COLOR}>-</ValueText>
              </BootstrapTooltip>
              )
            : (
              <ValueText small color={CONVERSION_COLOR}>
                {formatConversionRate(rate)}
              </ValueText>
              )}
          <ValueText small>
            {disabled
              ? '-'
              : `${conversion.sales.toLocaleString('pt-BR')} vendas de ${conversion.visitors.toLocaleString('pt-BR')} pessoas`}
          </ValueText>
        </ProgressContainer>
        <ProgressBar
          small
          progresscolor={disabled ? NEUTRAL_COLOR : CONVERSION_COLOR}
          value={disabled ? 0 : Math.min(rate, 100)}
        />
      </div>
    </CardContainer>
  )
}
